export const removeBlankSpaces = (text: string): string => text?.replace(/\s+/g, '');

export const capitalizeFirstLetter = (input: string | string[]): string => {
  if (typeof input === 'string') {
    return input.charAt(0).toUpperCase() + input.slice(1);
  }

  const [first = '', ...rest] = input || [''];
  return [first.toUpperCase(), ...rest].join('');
};

export const capitalized = (str: string): string => str[0].toUpperCase() + str.slice(1).toLowerCase();
